"use client";

import * as React from "react";

/**
 * Cho phép một trang đẩy tiêu đề (vd tên lớp) lên góc trái topbar.
 * AppShell giữ state; trang con gọi usePageTitle() để set/clear khi mount/unmount.
 */
const PageTitleContext = React.createContext<(node: React.ReactNode) => void>(() => {});

export function PageTitleProvider({
  setTitle,
  children,
}: {
  setTitle: (node: React.ReactNode) => void;
  children: React.ReactNode;
}) {
  return <PageTitleContext.Provider value={setTitle}>{children}</PageTitleContext.Provider>;
}

/** Đặt tiêu đề topbar cho vòng đời của component gọi (tự dọn khi unmount). */
export function usePageTitle(node: React.ReactNode) {
  const setTitle = React.useContext(PageTitleContext);
  React.useEffect(() => {
    setTitle(node);
    return () => setTitle(null);
  }, [setTitle, node]);
}
